package com.devi3east.bashbuddy.leaderboard.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class OrganizationLeaderboardItem(
    val organizationId: String,
    val organizationName: String,
    val eventCount: Int,
    val affiliateCount: Int,
    val stripeOnboardingComplete: Boolean
)